import { courseMakerOrigin } from "@/api_urls";

export const assetUrl = (path: string) => {
  return `${courseMakerOrigin}${path}`;
};
